export default "__VITE_ASSET__t6$FeAkD__"